//import 'bootstrap/dist/css/bootstrap.css';
import "@visa/vds/_stys/vds.min.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import registerServiceWorker from "./registerServiceWorker";
import { createBrowserHistory } from "history";
import ScrollToTop from "./components/ScrollToTop";

const rootElement = document.getElementById("root");
const appHistory = createBrowserHistory();

ReactDOM.render(
  <BrowserRouter history={appHistory}>
    <ScrollToTop />
    <App />
  </BrowserRouter>,
  rootElement
);

unregisterServiceWorker();
//registerServiceWorker();

if (process.env.REACT_APP_NODE_ENV !== "development") {
  console.log = () => {};
}

console.log("Environment:", process.env.REACT_APP_NODE_ENV, "- Debugging is enabled");
